import styles from "./Button.module.scss";

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  artist: "riize" | "aespa";
  label: string;
};

const Button = ({artist, label, ...props}: ButtonProps) => (
  <button className={`${styles.button} ${styles[artist]}`} {...props}>
    {label}
  </button>
);

export default Button;
